import { useMemo } from 'react';
import { useContent } from '../redux/reducer/content';
import { isMac } from '../utils/detector/detector';
import { useElf } from '../redux/reducer/elf';
import { exeptionRoom } from '../constants/exeptionRoom';

export const useBackgroundData = ({ items, extraRoom }) => {
  const { shopItems, slots, eventRooms } = useContent() ?? {};

  const { activeRoom } = useElf();

  const necessaryRoom = useMemo(() => {
    const typeRoomId = ['object', 'number'];

    const originId = eventRooms?.find(({ system_name }) => system_name === 'origin')?.id;

    if (typeof exeptionRoom !== 'string') {
      return typeRoomId.includes(typeof extraRoom) && eventRooms?.some?.(({ id }) => id === extraRoom)
        ? extraRoom
        : activeRoom;
    }

    const exeptionRoomId = eventRooms?.find(({ system_name }) => system_name === exeptionRoom)?.id;

    return typeRoomId.includes(typeof exeptionRoomId) ? exeptionRoomId : originId;
  }, [extraRoom, activeRoom, eventRooms]);

  const activeBackground = useMemo(() => {
    return eventRooms.find(({ id }) => id === necessaryRoom)?.background;
  }, [eventRooms, necessaryRoom]);

  const activeSystemName = useMemo(() => {
    return eventRooms?.find(({ id }) => id === necessaryRoom)?.system_name;
  }, [necessaryRoom, eventRooms]);

  return useMemo(() => {
    if (!items || !shopItems || !slots) return [];

    const availableSlots = Object.values(shopItems.room).reduce(
      (acc, { system_name, eventRoomId }) => (eventRoomId === necessaryRoom ? [...acc, system_name] : acc),
      [],
    );

    const background = activeBackground ? [activeBackground] : [];

    const itemsData = [...items]
      .sort((cur, next) => {
        const curSlot = slots.findIndex((slot) => slot.system_name === cur.slot);
        const nextSlot = slots.findIndex((slot) => slot.system_name === next.slot);
        return curSlot - nextSlot;
      })
      .reduce((acc, el) => {
        if (!el.is_equipped || !el.image || !availableSlots.includes(el?.slot)) return acc;
        return [...acc, isMac() ? el?.compressed_image ?? el.image : el.image];
      }, []);

    // Вставляем background на индекс 1 в itemsData
    const result = [...itemsData];
    if (background.length > 0) {
      result.splice(1, 0, ...background);
    }
    return result;
  }, [shopItems, slots, items, activeBackground, necessaryRoom, activeSystemName]);
};
